export function isValidPassword(password: string): boolean {
  if (password.length < 8) {
    return false;
  }

  return /[A-Z]/.test(password);
}
